import { IconLogin2 } from '@tabler/icons-react';
import { FormattedMessage } from 'react-intl';

import config from '@/config';
import { Button } from '@/modules/ui';

import * as felaRules from './RegisterButton.rules';

export const RegisterButton = () => (
    <Button
        type='default'
        icon={<IconLogin2 size={20} />}
        href={config.links.freeTierRegistration}
        target='_blank'
        rel='noopener noreferrer'
        customStyle={felaRules.container}
    >
        <FormattedMessage id='auth.login.button.register' />
    </Button>
);
